export default __webpack_public_path__ + "74f73ee4cade9e519052187f307af99c.png";